import React from 'react';

export default function PortfolioBacktestPage(props) {
  // Pass all props to the original PortfolioBacktest component
  // This is a wrapper for modularization
  return <div style={{ minHeight: '400px', fontFamily: 'Inter, Segoe UI, Arial, sans-serif' }}><props.Component {...props} /></div>;
}
